module.exports = __webpack_public_path__ + "img/Golf Clubs mobile.90395ffc.png";